import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    /*
    asdf({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'url/', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    */
    estudio_panelMonosRi() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'estudio/panel-monos-ri')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};